import { AssertException } from '../assert.exception';

export class AssertIsFunctionException extends AssertException {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, AssertIsFunctionException.prototype);
  }
}
